import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthInterceptors } from "./lib/authToken";

// Install Safari-ITP-tolerant Authorization: Bearer fallback before any
// component mounts so the very first /auth/me call already carries the token.
installAuthInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
